export class RequestCounters
{
    public totalTickets: number;

    constructor (public userTickets: number = 0, public teamTickets: number = 0)
    {
        this.totalTickets = this.teamTickets + this.userTickets;
    }
}
